import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { JoinBlogDetailComponent } from './join-blog-detail.component';
import { BlogDetailInnerComponent } from '../blog-detail-inner/blog-detail-inner.component';
import { BlogDetailComponent } from '../blog-detail/blog-detail.component';
import { FullModule } from '../layouts/full/full.module';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { OuterHeaderNavigationModule } from '../shared/outer-header-navigation/outer-header-navigation.module';

const routes: Routes = [
  { path: '', component: JoinBlogDetailComponent },
  // { path: '**', redirectTo: '/index', pathMatch: 'full' }
]

@NgModule({
  declarations: [
    JoinBlogDetailComponent,
    BlogDetailComponent,
    BlogDetailInnerComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    FullModule,
    FormsModule,
    BsDropdownModule,
    NgbModule,
    InfiniteScrollModule,
    OuterHeaderNavigationModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class JoinBlogDetailModule { }
